import { logEvent } from './analyticsUtils';

const revenueAnalytics = () => {
  const ANALYTICS_EVENTS = {
    UpgradeInsider: 'upgrade_insider',
  };

  const logUpgradeInsider = () => {
    logEvent(ANALYTICS_EVENTS.UpgradeInsider);
  };

  return {
    logUpgradeInsider,
  };
};

export default revenueAnalytics();
